import { FETCH_PRODUCT_DETAIL_PENDING, FETCH_PRODUCT_DETAIL_REJECT, FETCH_PRODUCT_DETAIL_SUCCESS, FETCH_PRODUCT_PENDING, FETCH_PRODUCT_REJECT, FETCH_PRODUCT_SUCCESS } from "./actionType"

const BASE_URL = 'https://yyy.willy-clover.site'
// const BASE_URL = 'http://localhost:5000'

export const fetchProductPending = () => ({
    type: FETCH_PRODUCT_PENDING,
})

export const fetchProductSuccess = (responseJSON) => ({
    type: FETCH_PRODUCT_SUCCESS,
    payload: responseJSON
})

export const fetchProductReject = (errorMessage) => ({
    type: FETCH_PRODUCT_REJECT,
    payload: errorMessage
})

export const fetchProductDetailPending = () => ({
    type: FETCH_PRODUCT_DETAIL_PENDING,
})

export const fetchProductDetailSuccess = (responseJSON) => ({
    type: FETCH_PRODUCT_DETAIL_SUCCESS,
    payload: responseJSON
})

export const fetchProductDetailReject = (errorMessage) => ({
    type: FETCH_PRODUCT_DETAIL_REJECT,
    payload: errorMessage
})

export const fetchProduct = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(fetchProductPending())

            let response = await fetch(`${BASE_URL}/pub/products`)
            if (!response.ok) {
                throw new Error(await response.text())
            }
            let responseJSON = await response.json()
            
            dispatch(fetchProductSuccess(responseJSON))
        } catch (err) {
            dispatch(fetchProductReject(err))
            throw new Error(err)
        }
    }
}

export const fetchProductDetail = (productSlug) => {
    return async (dispatch, getState) => {
        try {
            dispatch(fetchProductDetailPending())
            
            let response = await fetch(`${BASE_URL}/pub/products/${productSlug}`)
            if (!response.ok) {
                throw new Error(await response.text())
            }

            let responseJSON = await response.json()
            dispatch(fetchProductDetailSuccess(responseJSON))
        } catch (err) {
            dispatch(fetchProductDetailReject(err))
            throw new Error(err)
        }
    }
}